module.exports = __webpack_public_path__ + "static/media/img3.19dd6b27.jpg";